// Extra client-site screenshots for Sanity-synthesized case studies
// (positions 7+ on /work that aren't in the curated NAMED_CASES).
import eastWestCenterShot from "@/assets/case-screenshots/eastwestcenter.png.asset.json";
import configeroShot from "@/assets/case-screenshots/configero.png.asset.json";
import doctorsShot from "@/assets/case-screenshots/doctorswithoutborders.png.asset.json";
import mauticShot from "@/assets/case-screenshots/mautic.png.asset.json";
import redhatShot from "@/assets/case-screenshots/redhat-developers.png.asset.json";
import scoutsShot from "@/assets/case-screenshots/scouts.png.asset.json";
import facetShot from "@/assets/case-screenshots/facetinteractive.png.asset.json";
import sunyShot from "@/assets/case-screenshots/sunymaritime.png.asset.json";
import synduitShot from "@/assets/case-screenshots/synduit.png.asset.json";
import castShot from "@/assets/case-screenshots/cast.png.asset.json";
import amaShot from "@/assets/case-screenshots/freida-ama.png.asset.json";
import franklinMadisonShot from "@/assets/case-screenshots/franklin-madison-hero.png.asset.json";
import raceForwardShot from "@/assets/case-screenshots/race-forward.webp";

export const EXTRA_SCREENSHOTS: Record<string, { url: string; siteUrl: string }> = {
  "sales-experience-marketing-automation-platform-franklin-madison": {
    url: franklinMadisonShot.url,
    siteUrl: "franklin-madison.com",
  },
  "east-west-center-platform-modernization-user-engagement": {
    url: eastWestCenterShot.url,
    siteUrl: "eastwestcenter.org",
  },
  "exceptional-customer-support-through-salesforce-einstein-chatbot": {
    url: configeroShot.url,
    siteUrl: "configero.com",
  },
  "drupal-transformation-doctors-without-borders-website": {
    url: doctorsShot.url,
    siteUrl: "doctorswithoutborders.org",
  },
  "engineering-plugins-for-acquia-campaign-studio-mautic": {
    url: mauticShot.url,
    siteUrl: "mautic.org",
  },
  "revamping-red-hat-developer-portal": {
    url: redhatShot.url,
    siteUrl: "developers.redhat.com",
  },
  "support-for-the-worldwide-scout-movement": {
    url: scoutsShot.url,
    siteUrl: "scout.org",
  },
  "the-facet-axelerant-partnership": {
    url: facetShot.url,
    siteUrl: "facetinteractive.com",
  },
  "suny-maritime-college-drupal-migration": {
    url: sunyShot.url,
    siteUrl: "sunymaritime.edu",
  },
  "continuous-support-for-synduits-network-marketing-platform": {
    url: synduitShot.url,
    siteUrl: "synduit.com",
  },
  "learningdesigned-cast-drupal-audit": {
    url: castShot.url,
    siteUrl: "cast.org",
  },
  "transformation-ama-digital-platform": {
    url: amaShot.url,
    siteUrl: "freida.ama-assn.org",
  },
  "race-forward-multi-site-drupal-migration": {
    url: raceForwardShot,
    siteUrl: "raceforward.org",
  },
};

